class InternalDoor {
  constructor() {
    this.buyingJourney = document.querySelector('buying-journey');
    this.configurationPopup = document.querySelector('configuration-popup');
    this.skipAstragalStep = false;
    this.aluminiumBifold = this;
    this.buyingJourneyApi = this.buyingJourney.buyingJourneyApi;
    // Dispatch the change event immediately after setting up the event listener

    //Object holding the information for whole Buying Journey.
    this.buyingJourneyObject = {
      id: null,
      title: null,
      panelInfo: { panelWidth: null, panelHeight: null, orientation: null },
      panelSize: {
        value: null,
        variantId: null,
        totalPrice: 0,
        quantity: 1,
        panelImage: null,
        stackingDirection: null,
      },
      panelOutsideColour: { value: null, variantId: null, quantity: 1, totalPrice: 0 },
      panelInsideColour: { value: null, variantId: null, quantity: 1, totalPrice: 0 },
      panelHandle: { value: null, variantId: null, quantity: 1, totalPrice: 0 },
      panelGlass: { value: null, variantId: null, quantity: 1, totalPrice: 0 },
      blinds: { value: null, variantId: null, quantity: 1, totalPrice: 0 },
      barsfitting: {
        value: null,
        typeVariantId: null,
        orientationVariantId: null,
        quantityVariantId: null,
        quantity: 0,
        totalPrice: 0,
        direction: null,
      },
      trickleVents: { value: null, variantId: null, quantity: 1, totalPrice: 0 },
      profileAddons: { left: null, leftPrice: 0, right: null, rightPrice: 0, top: null, topPrice: 0, value: null },
      postCode: { value: null },
      cill: { value: null, totalPrice: 0, variantId: null, quantity: 1 },
      threshold: { value: null, totalPrice: 0, variantId: null },
      accessIssue: { value: null, orderNote: null },
      gtAccessQoute: { firstName: null, lastName: null, mobile: null, email: null },
      totalPrice: 0,
      invoiceUrl: null,
    };

    // step functions that will perform calculation based on selection in previous steps
    this.stepActions = {
      0: () => this.getWindowSize(this.buyingJourneyObject, this.buyingJourney.querySelectorAll('.step-size input')),
      1: this.calculatePanelSize.bind(this),
      2: this.getPanelSize.bind(this),
      3: this.getOrientation.bind(this),
      4: this.getOutsideColor.bind(this),
      5: this.getInsideColor.bind(this),
      6: this.getPanelHandle.bind(this),
      7: this.getGlassType.bind(this),
      8: this.getBlind.bind(this),
      9: this.getBarsFittingType.bind(this),
      10: this.getBarsFittingOrientation.bind(this),
      11: this.getBarsFittingQuantity.bind(this),
      12: this.getTrickleVents.bind(this),
      13: this.handleThreshold.bind(this),
      14: this.getThreshold.bind(this),
      15: this.getCill.bind(this),
      16: this.getpostcode.bind(this),
      17: this.getGatewayAccessQuote.bind(this),
      18: this.handleAddMoreProducts.bind(this),
      19: this.buyingJourney.readyQuoteOverview.bind(this.buyingJourney),
    };
  }

  connectedCallback() {
    this.render();
  }

  render() {}

  //First step assign event listener to input fields
  getWindowSize(productObject, inputs) {
    console.log('Panel width and height');
    const isInsideConfigPopup = !!inputs[0].closest('configuration-popup');
    inputs.forEach((input) => {
      if (input.name == 'panel-width') {
        input.value = productObject.panelInfo.panelWidth;
      }
      if (input.name == 'panel-height') {
        input.value = productObject.panelInfo.panelHeight;
      }
      //this.validateInput(productObject,input);
      if (isInsideConfigPopup) {
        console.log('Yes inside', this.validateInput(productObject, input));
        this.validateInput(productObject, input)
          ? this.configurationPopup.setActiveNextButton()
          : this.configurationPopup.setDisableNextButton();
        input.addEventListener('input', () =>
          this.validateInput(productObject, input)
            ? this.configurationPopup.setActiveNextButton()
            : this.configurationPopup.setDisableNextButton()
        );
      } else {
        this.validateInput(productObject, input)
          ? this.buyingJourney.setActiveNextButton()
          : this.buyingJourney.setDisableNextButton();
        input.addEventListener('input', () =>
          this.validateInput(productObject, input)
            ? this.buyingJourney.setActiveNextButton()
            : this.buyingJourney.setDisableNextButton()
        );
      }
      input.dispatchEvent(this.buyingJourney.changeEvent);
    });
  }

  //Based on added width and height calcualte the Panel Size for Step 2
  calculatePanelSize() {
    console.log('No. of panels ');
    console.log(this);
    const panels = this.buyingJourney.querySelectorAll('.offered-product-wrapper .panel-wrapper');
    panels.forEach((panel) => {
      if (panel) {
        const panelSizeInput = panel.querySelector('input[name="panel_size"]');
        panel.classList.add('hidden');
        if (panelSizeInput) {
          const panelSizeValue = parseInt(panelSizeInput.dataset.panelSize) || 0;
          const panelOption1 = panelSizeInput.dataset.option1;
          const panelMinWidth = panelSizeValue * 600;
          const panelMaxWidth = panelSizeValue * 1200;
          const similarPanel = this.buyingJourney.querySelectorAll('input[data-option1="' + panelOption1 + '"]');
          if (similarPanel) {
            for (var i = 0; i < similarPanel.length; i++) {
              if (
                similarPanel[i].dataset.panelHeight >= this.buyingJourneyObject.panelInfo.panelHeight &&
                this.buyingJourneyObject.panelInfo.panelWidth >= panelMinWidth &&
                this.buyingJourneyObject.panelInfo.panelWidth <= panelMaxWidth
              ) {
                similarPanel[i].parentElement.classList.remove('hidden');
                if (
                  this.buyingJourneyObject.panelSize.variantId != null &&
                  similarPanel[i].dataset.variantId == this.buyingJourneyObject.panelSize.variantId
                ) {
                  similarPanel[i].checked = true;
                }
                break;
              }
            }
          }
        }
      }
    });
    this.setupOptionListeners('input[name="panel_size"]');
  }

  //Step 3: show orientation and get panel size based on height and width
  getPanelSize() {
    console.log('Orientation');

    if (this.buyingJourneyObject.panelInfo.orientation != null) {
      const selectedOrientation = this.buyingJourney.querySelector(
        'input[value="' + this.buyingJourneyObject.panelInfo.orientation + '"]'
      );
      selectedOrientation.checked = true;
      selectedOrientation.dispatchEvent(this.buyingJourney.changeEvent);
    }

    const selectedPanel = this.buyingJourney.querySelector('input[name="panel_size"]:checked');
    if (selectedPanel) {
      this.buyingJourneyObject.panelSize.value = selectedPanel.dataset.panelSize || null;
      this.buyingJourneyObject.panelSize.variantId = selectedPanel.dataset.variantId || null;
      this.buyingJourneyObject.panelSize.totalPrice = this.convertPrice(selectedPanel.dataset.price);
      this.buyingJourneyObject.panelSize.panelImage = selectedPanel.nextElementSibling.querySelector('img').src;
      if (selectedPanel.dataset.option1.includes('Left')) {
        this.buyingJourneyObject.panelSize.stackingDirection = 'Left';
      } else if (selectedPanel.dataset.option1.includes('Right')) {
        this.buyingJourneyObject.panelSize.stackingDirection = 'Right';
      } else {
        const sizeLeft = selectedPanel.dataset.option1.split('_')[0];
        const sizeRight = selectedPanel.dataset.option1.split('_')[2];
        this.buyingJourneyObject.panelSize.stackingDirection =
          sizeLeft + ' Left , ' + (sizeRight ? sizeRight + ' Right' : '');
      }
    }

    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="orientation"]');
  }

  //Step 4: show outside colour and get selected orientation
  getOrientation() {
    console.log('Outside Colour');
    if (this.buyingJourneyObject.panelOutsideColour.variantId != null) {
      const selectedColorOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' + this.buyingJourneyObject.panelOutsideColour.variantId + '"]'
      );
      selectedColorOption.checked = true;
      selectedColorOption.dispatchEvent(this.buyingJourney.changeEvent);
    }
    const selectedOrientation = this.buyingJourney.querySelector('input[name="orientation"]:checked');
    if (selectedOrientation) {
      this.buyingJourneyObject.panelInfo.orientation = selectedOrientation.value || '';
    }

    document.querySelectorAll('input[name="panel_outside_color"]').forEach((colourItem) => {
      colourItem.addEventListener('change', function () {});
    });
    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="panel_outside_color"]');
  }

  //Step 5: show inside colour and get selected outside colour
  getOutsideColor() {
    console.log('Inside Colour');
    if (this.buyingJourneyObject.panelInsideColour.variantId != null) {
      const selectedColorOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' + this.buyingJourneyObject.panelInsideColour.variantId + '"]'
      );
      selectedColorOption.checked = true;
      selectedColorOption.dispatchEvent(this.buyingJourney.changeEvent);
    }
    const selectedOutsideColor = this.buyingJourney.querySelector('input[name="panel_outside_color"]:checked');
    this.buyingJourney.querySelectorAll('input[name="panel_inside_color"]').forEach((insideColour) => {
      if (
        !(
          insideColour.value == selectedOutsideColor.value ||
          insideColour.value.includes('RAL') ||
          insideColour.value.includes('white')
        )
      ) {
        insideColour.parentElement.classList.add('hidden');
        console.log(insideColour.value);
      } else {
        //insideColour.checked = true;
        insideColour.parentElement.classList.remove('hidden');
      }
    });

    if (selectedOutsideColor) {
      this.buyingJourneyObject.panelOutsideColour.value = selectedOutsideColor.dataset.ralvalue || null;
      this.buyingJourneyObject.panelOutsideColour.variantId = selectedOutsideColor.dataset.variantId || null;
      this.buyingJourneyObject.panelOutsideColour.totalPrice = this.convertPrice(selectedOutsideColor.dataset.price);
      this.buyingJourneyObject.panelOutsideColour.quantity = parseInt(this.buyingJourneyObject.panelSize.value) || 1;
    }

    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="panel_inside_color"]');
  }

  //Step 6: Show Handles and get the selected inside colours
  getInsideColor() {
    console.log('Handles');
    this.setupOptionListeners('input[name="handles"]');

    const selectedInsideColor = this.buyingJourney.querySelector('input[name="panel_inside_color"]:checked');

    if (selectedInsideColor) {
      this.buyingJourneyObject.panelInsideColour.value = selectedInsideColor.dataset.ralvalue || null;
      this.buyingJourneyObject.panelInsideColour.variantId = selectedInsideColor.dataset.variantId || null;
      this.buyingJourneyObject.panelInsideColour.totalPrice = this.convertPrice(selectedInsideColor.dataset.price);
      this.buyingJourneyObject.panelInsideColour.quantity = parseInt(this.buyingJourneyObject.panelSize.value) || 1;
    }

    if (this.buyingJourneyObject.panelHandle.variantId != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' + this.buyingJourneyObject.panelHandle.variantId + '"]'
      );
      selectedOption.checked = true;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    this.buyingJourney.nextStepButton.dataset.increment = 0;
  }

  //Step 7: show glass sizes and get the selected handles
  getPanelHandle() {
    const glassSize =
      (this.buyingJourneyObject.panelInfo.panelWidth / 1000) * (this.buyingJourneyObject.panelInfo.panelHeight / 1000);
    const glassSizeOptions = this.buyingJourney.querySelectorAll('input[name="glass_size"]');
    const classInstance = this;
    glassSizeOptions.forEach((radio) => {
      radio.addEventListener('change', function () {
        checkForSelectedGlass(this);
      });

      if (radio && radio.dataset.variantPrice > 0) {
        const totalGlassPrice = Math.round(parseFloat(radio.dataset.variantPrice).toFixed(2) * glassSize);
        radio.dataset.price = totalGlassPrice;
        const panelPriceElement = radio.nextElementSibling.querySelector('.panel-price');
        if (panelPriceElement) {
          panelPriceElement.innerHTML =
            totalGlassPrice === 0 ? '<span class="free-badge">Free included </span>' : '+£' + totalGlassPrice;
        }
      }
    });

    const selectedGlass = this.buyingJourney.querySelector('input[name="glass_size"]:checked');

    if (selectedGlass) {
      checkForSelectedGlass(selectedGlass);
    }

    const selectedHandle = this.buyingJourney.querySelector('input[name="handles"]:checked');

    if (selectedHandle) {
      this.buyingJourneyObject.panelHandle.value = selectedHandle.value || null;
      this.buyingJourneyObject.panelHandle.variantId = selectedHandle.dataset.variantId || null;
      this.buyingJourneyObject.panelHandle.totalPrice = this.convertPrice(selectedHandle.dataset.price);
    }

    if (this.buyingJourneyObject.panelGlass.variantId != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' + this.buyingJourneyObject.panelGlass.variantId + '"]'
      );
      selectedOption.checked = true;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    this.buyingJourney.prevStepButton.dataset.decrement = 0;
    this.setupOptionListeners('input[name="glass_size"]');

    function checkForSelectedGlass(radio) {
      if (
        radio.value.includes('standard-low-e-tough-1.2-u-value') ||
        radio.value.includes('tough-ultra-low-e-1.1u') ||
        radio.value.includes('tough-solar-control-1-u-value')
      ) {
        classInstance.buyingJourney.nextStepButton.dataset.increment = 0;
      } else {
        console.log('Skip blind step');
        classInstance.buyingJourney.nextStepButton.dataset.increment = 1;
      }
    }
    console.log(this.buyingJourneyObject);
  }

  updateGlassValues() {
    const selectedGlass = this.buyingJourney.querySelector('input[name="windows-glass_size"]:checked');

    if (selectedGlass) {
      this.buyingJourneyObject.panelGlass.value = selectedGlass.value;
      this.buyingJourneyObject.panelGlass.variantId = selectedGlass.dataset.variantId;
      const pricePerSqm = selectedGlass.dataset.variantPrice * 100;
      const totalPrice = pricePerSqm * this.buyingJourneyObject.panelInfo.summary.totalSqm;
      this.buyingJourneyObject.panelGlass.totalPrice = this.convertPrice(totalPrice) / 100;
    }
  }

  //Step 8: Show the Bars fitting type and get the selected glass type.
  getGlassType() {
    console.log('Blinds');

    this.updateGlassValues(); // update the glass values

    const windowBlinds = this.buyingJourney.querySelectorAll('input[name="blinds"]');

    windowBlinds.forEach((blind) => {
      const blindsPrice = this.convertPrice(blind.dataset.price) * parseInt(this.buyingJourneyObject.panelSize.value);
      console.log('blindprice =' + blindsPrice);
      blind.nextElementSibling.querySelector('.panel-price').innerHTML = '£' + blindsPrice;
      blind.nextElementSibling.querySelector('.panel-price').dataset.finalPrice = blindsPrice;
      console.log('blindfinalprice = ' + blind.nextElementSibling.querySelector('.panel-price').dataset.finalPrice);

      // Add change event listener to each blind option
      blind.addEventListener('change', () => {
        // If they select "yes" to blinds, set increment to 3 to skip steps 9, 10, and 11
        if (blind.value.toLowerCase() === 'yes') {
          this.buyingJourney.nextStepButton.dataset.increment = 3;
          console.log('Skip steps 9, 10, and 11 because blinds = yes');
          getBlind();
          this.skipAstragalStep = true;
        }
        // If they select "no" to blinds, set increment to 0 to not skip any steps
        else if (blind.value.toLowerCase() === 'no') {
          this.buyingJourney.nextStepButton.dataset.increment = 0;
          console.log('Keep steps 9, 10, and 11 because blinds = no');
          this.skipAstragalStep = false;
        }
      });
    });

    if (this.buyingJourneyObject.blinds.variantId != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' + this.buyingJourneyObject.panelGlass.variantId + '"]'
      );
      selectedOption.checked = true;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);

      // If blind is already selected in the product object, check its value and set increment accordingly
      const selectedBlind = this.buyingJourney.querySelector('input[name="blinds"]:checked');
      if (selectedBlind) {
        if (selectedBlind.value.toLowerCase() === 'yes') {
          this.buyingJourney.nextStepButton.dataset.increment = 3;
          console.log('Skip steps 9, 10, and 11 because blinds = yes (from previously selected)');
          getBlind();
          this.skipAstragalStep = true;
        } else {
          this.buyingJourney.nextStepButton.dataset.increment = 0;
          console.log('Keep steps 9, 10, and 11 because blinds = no (from previously selected)');
          this.skipAstragalStep = false;
        }
      }
    }
    this.buyingJourney.prevStepButton.dataset.decrement = 0;
    this.setupOptionListeners('input[name="blinds"]');
    console.log(this.buyingJourneyObject);
  }

  // Step 9: Show the blind
  getBlind() {
    console.log('Panel Bar Type');

    const fittingBarsOptions = this.buyingJourney.querySelectorAll('input[name="panel_bar_type"]');
    fittingBarsOptions.forEach((radio) => {
      radio.addEventListener('change', () => {
        console.log(this);
        const selectedFitting = this.buyingJourney.querySelector('input[name="panel_bar_type"]:checked');
        this.buyingJourneyObject.barsfitting.value = selectedFitting.value;
        this.buyingJourneyObject.barsfitting.typeVariantId = selectedFitting.dataset.variantId;
        this.setIncrementForButtons(selectedFitting.value, 8);
      });
    });

    const selectedGlass = this.buyingJourney.querySelector('input[name="glass_size"]:checked');

    if (selectedGlass) {
      this.buyingJourneyObject.panelGlass.value = selectedGlass.value;
      this.buyingJourneyObject.panelGlass.variantId = selectedGlass.dataset.variantId;
      this.buyingJourneyObject.panelGlass.totalPrice = this.convertPrice(selectedGlass.dataset.price);

      if (
        selectedGlass.value.includes('standard-low-e-tough-1.2-u-value') ||
        selectedGlass.value.includes('tough-ultra-low-e-1-u-value') ||
        selectedGlass.value.includes('tough-solar-control-1-u-value')
      ) {
        this.buyingJourney.prevStepButton.dataset.decrement = 0;
        const selectedBlind = this.buyingJourney.querySelector('input[name="blinds"]:checked');
        if (selectedBlind) {
          const finalPriceBlindElement = selectedBlind.nextElementSibling.querySelector(
            '.panel-price[data-final-price]'
          );
          this.buyingJourneyObject.blinds.value = selectedBlind.value;
          this.buyingJourneyObject.blinds.variantId = selectedBlind.dataset.variantId;
          console.log('blindfinalprice after selected blind =' + finalPriceBlindElement.dataset.finalPrice);
          this.buyingJourneyObject.blinds.totalPrice = this.convertPrice(finalPriceBlindElement.dataset.finalPrice);
        }
      } else {
        this.buyingJourneyObject.blinds.value = null;
        this.buyingJourneyObject.blinds.variantId = null;
        this.buyingJourneyObject.blinds.totalPrice = 0;
        this.buyingJourney.prevStepButton.dataset.decrement = 1;
      }
    }

    if (this.buyingJourneyObject.barsfitting.typeVariantId != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' + this.buyingJourneyObject.barsfitting.typeVariantId + '"]'
      );
      selectedOption.checked = true;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    this.setupOptionListeners('input[name="panel_bar_type"]');
  }

  //Step 9: Show the Bars Orientation and get the selected bars type.
  getBarsFittingType() {
    console.log('Bars Fitting Orientation');

    if (this.buyingJourneyObject.barsfitting.orientationVariantId != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' + this.buyingJourneyObject.barsfitting.orientationVariantId + '"]'
      );
      selectedOption.checked = true;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }
    this.buyingJourney.prevStepButton.dataset.decrement = 0;
    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="panel_bar_orientation"]');
  }

  getBarsFittingOrientation() {
    console.log('Bars Fitting Quantity');
    if (this.buyingJourneyObject.barsfitting.quantityVariantId != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' + this.buyingJourneyObject.barsfitting.quantityVariantId + '"]'
      );
      selectedOption.checked = true;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    const selectedFittingOrientation = this.buyingJourney.querySelector('input[name="panel_bar_orientation"]:checked');
    const quantityFittingBars = this.buyingJourney.querySelectorAll('input[name="panel_bar_quantity"]');

    if (selectedFittingOrientation) {
      quantityFittingBars.forEach((element) => {
        const isSameDirection = element.dataset.variantTitle
          .toLowerCase()
          .includes(selectedFittingOrientation.value.toLowerCase());
        element.parentElement.classList.toggle('hidden', !isSameDirection);
      });

      this.buyingJourneyObject.barsfitting.direction = selectedFittingOrientation.value;
      this.buyingJourneyObject.barsfitting.orientationVariantId = selectedFittingOrientation.dataset.variantId;
    }

    const selectedBarsFitting = this.buyingJourney.querySelector('input[name="panel_bar_type"]:checked');
    if (selectedBarsFitting) {
      if (selectedBarsFitting.value == 'transom') {
        selectedBarsFitting
          .closest('.step-container')
          .nextElementSibling.nextElementSibling.querySelector('.step-heading').innerHTML =
          "Choose the number of Transom bars you'd like to add.";
        this.buyingJourney.prevStepButton.dataset.decrement = 1;
        this.buyingJourney.nextStepButton.dataset.increment = 0;
      } else {
        selectedBarsFitting
          .closest('.step-container')
          .nextElementSibling.nextElementSibling.querySelector('.step-heading').innerHTML =
          'Choose the number of ' +
          this.buyingJourneyObject.barsfitting.direction +
          " Astragal bars you'd like to add.";
      }
    }

    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="panel_bar_quantity"]');
  }

  getBarsFittingQuantity() {
    console.log('Trickle Vents');

    if (this.buyingJourneyObject.trickleVents.variantId != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' + this.buyingJourneyObject.trickleVents.variantId + '"]'
      );
      selectedOption.checked = true;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }
    const selectedFittingQuantity = this.buyingJourney.querySelector('input[name="panel_bar_quantity"]:checked');
    const selectedBarsFitting = this.buyingJourney.querySelector('input[name="panel_bar_type"]:checked');

    if (this.skipAstragalStep) {
      this.setDecrementForButtons('skipAstragal');
    } else {
      if (selectedBarsFitting) {
        this.setDecrementForButtons(selectedBarsFitting.value);
      }
    }

    if (selectedFittingQuantity) {
      this.buyingJourneyObject.barsfitting.quantityVariantId = selectedFittingQuantity.dataset.variantId;
      this.buyingJourneyObject.barsfitting.quantity = parseInt(selectedFittingQuantity.value);
      this.buyingJourneyObject.barsfitting.totalPrice = this.convertPrice(
        selectedFittingQuantity.dataset.price * this.buyingJourneyObject.barsfitting.quantity
      );
    }

    this.buyingJourney.nextStepButton.dataset.increment = 0;
    console.log(this.buyingJourneyObject);
    this.setupOptionListeners('input[name="trickle-vent"]');
  }

  getTrickleVents() {
    console.log('Profile Addons');

    const selectedBarsFitting = this.buyingJourney.querySelector('input[name="panel_bar_type"]:checked');
    if (selectedBarsFitting) {
      this.setDecrementForButtons(selectedBarsFitting.value);
      if (selectedBarsFitting.value == 'no') {
        this.buyingJourneyObject.barsfitting.quantity = 0;
        this.buyingJourneyObject.barsfitting.totalPrice = 0;
        this.buyingJourneyObject.barsfitting.direction = null;
      }
    }

    const selectedTrickleOption = this.buyingJourney.querySelector('input[name="trickle-vent"]:checked');
    if (selectedTrickleOption) {
      this.buyingJourneyObject.trickleVents.value = selectedTrickleOption.value;
      this.buyingJourneyObject.trickleVents.variantId = selectedTrickleOption.dataset.variantId;
      this.buyingJourneyObject.trickleVents.totalPrice = this.convertPrice(selectedTrickleOption.dataset.price);
    }

    const isAddonsNotRequired = this.buyingJourney.querySelector('input[name="addons_notRequired"]');
    isAddonsNotRequired.addEventListener('change', function () {
      getAddonProfile(isAddonsNotRequired.checked);
    });
    isAddonsNotRequired.dispatchEvent(this.buyingJourney.changeEvent);

    console.log(this.buyingJourneyObject);
    this.buyingJourney.prevStepButton.dataset.decrement = 0;
  }

  getAddonProfile(isAddonsNotRequired) {
    const left_side = this.buyingJourney.querySelector('select[name="left_side"]');
    const right_side = this.buyingJourney.querySelector('select[name="right_side"]');
    const top_side = this.buyingJourney.querySelector('select[name="top_side"]');

    setDisableforAddonprofiles();

    if (isAddonsNotRequired == false) {
      console.log('Addons Required');

      if (left_side) {
        let selectedLeftFrameLength = left_side.options[left_side.selectedIndex];
        this.buyingJourneyObject.profileAddons.left = '0mm';
        left_side.addEventListener('change', function () {
          selectedLeftFrameLength = left_side.options[left_side.selectedIndex];
          this.buyingJourneyObject.profileAddons.left = selectedLeftFrameLength.value;
          this.buyingJourneyObject.profileAddons.leftPrice = this.convertPrice(
            selectedLeftFrameLength.dataset.price * (this.buyingJourneyObject.panelInfo.panelHeight / 1000)
          );
          setDisableforAddonprofiles();
        });
      }
      if (right_side) {
        let selectedRightFrameLength = right_side.options[right_side.selectedIndex];
        this.buyingJourneyObject.profileAddons.right = '0mm';
        right_side.addEventListener('change', function () {
          selectedRightFrameLength = right_side.options[right_side.selectedIndex];
          this.buyingJourneyObject.profileAddons.right = selectedRightFrameLength.value;
          this.buyingJourneyObject.profileAddons.rightPrice = this.convertPrice(
            selectedRightFrameLength.dataset.price * (this.buyingJourneyObject.panelInfo.panelHeight / 1000)
          );
          setDisableforAddonprofiles();
        });
      }
      if (top_side) {
        let selectedTopFrameLength = top_side.options[top_side.selectedIndex];
        this.buyingJourneyObject.profileAddons.top = '0mm';
        top_side.addEventListener('change', function () {
          selectedTopFrameLength = top_side.options[top_side.selectedIndex];
          this.buyingJourneyObject.profileAddons.top = selectedTopFrameLength.value;
          this.buyingJourneyObject.profileAddons.topPrice = this.convertPrice(
            selectedTopFrameLength.dataset.price * (this.buyingJourneyObject.panelInfo.panelWidth / 1000)
          );
          setDisableforAddonprofiles();
        });
      }
      if (this.buyingJourneyObject.profileAddons.left != null) {
        const selectedOption = this.buyingJourney.querySelector('select[name="left_side"]');
        selectedOption.value = this.buyingJourneyObject.profileAddons.left;
        // selectedOption.dispatchEvent(this.buyingJourney.changeEvent)
      }

      if (this.buyingJourneyObject.profileAddons.right != null) {
        const selectedOption = this.buyingJourney.querySelector('select[name="right_side"]');
        selectedOption.value = this.buyingJourneyObject.profileAddons.right;
      }

      if (this.buyingJourneyObject.profileAddons.top != null) {
        const selectedOption = this.buyingJourney.querySelector('select[name="top_side"]');
        selectedOption.value = this.buyingJourneyObject.profileAddons.top;
        //selectedOption.dispatchEvent(changeEvent)
      }

      this.buyingJourneyObject.profileAddons.value = 'Required';
    } else {
      this.buyingJourneyObject.profileAddons = {};
      this.buyingJourneyObject.profileAddons.value = 'Not Required';
      this.buyingJourneyObject.profileAddons.left = '0mm';
      this.buyingJourneyObject.profileAddons.leftPrice = 0;
      this.buyingJourneyObject.profileAddons.top = '0mm';
      this.buyingJourneyObject.profileAddons.topPrice = 0;
      this.buyingJourneyObject.profileAddons.right = '0mm';
      this.buyingJourneyObject.profileAddons.rightPrice = 0;
    }

    function setDisableforAddonprofiles() {
      if (
        isAddonsNotRequired == false &&
        (left_side.value == 'no' || right_side.value == 'no' || top_side.value == 'no')
      ) {
        this.buyingJourney.setDisableNextButton();
      } else {
        this.buyingJourney.setActiveNextButton();
      }
    }
    this.buyingJourney.nextStepButton.dataset.increment = 0;
    console.log(this.buyingJourneyObject);
  }

  handleThreshold() {
    console.log('Handle Threshold');
    if (this.buyingJourneyObject.threshold.variantId != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' + this.buyingJourneyObject.threshold.variantId + '"]'
      );
      selectedOption.checked = true;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }
    const integratedThresholdAndCill = this.buyingJourney.querySelector(
      'input[name="threshold"][value="integrated-threshold-/-cill"]'
    );

    if (this.buyingJourneyObject.panelInfo.orientation == 'inwards' && integratedThresholdAndCill) {
      integratedThresholdAndCill.parentElement.classList.add('hidden');
    } else {
      integratedThresholdAndCill.parentElement.classList.remove('hidden');
    }
    const thresholdOptions = document.querySelectorAll('input[name="threshold"]');

    thresholdOptions.forEach((option) => {
      option.addEventListener('click', function () {
        if (option.value.includes('integrated')) {
          this.buyingJourney.nextStepButton.dataset.increment = 1;
        } else {
          this.buyingJourney.nextStepButton.dataset.increment = 0;
        }
      });
    });

    const selectedThreshold = document.querySelector('input[name="threshold"]:checked');

    if (selectedThreshold) {
      if (selectedThreshold.value.includes('integrated')) {
        this.buyingJourney.nextStepButton.dataset.increment = 1;
      } else {
        this.buyingJourney.nextStepButton.dataset.increment = 0;
      }
    }

    this.buyingJourney.prevStepButton.dataset.decrement = 0;
    this.setupOptionListeners('input[name="threshold"]');

    console.log(this.buyingJourneyObject);
  }

  getThreshold() {
    console.log('Cill');

    const selectedThreshold = document.querySelector('input[name="threshold"]:checked');

    if (selectedThreshold) {
      this.buyingJourneyObject.threshold.value = selectedThreshold.value;
      this.buyingJourneyObject.threshold.variantId = selectedThreshold.dataset.variantId;
      this.buyingJourneyObject.threshold.totalPrice = this.convertPrice(selectedThreshold.dataset.price);
    }

    if (this.buyingJourneyObject.cill.variantId != null) {
      const selectedOption = this.buyingJourney.querySelector(
        'input[data-variant-id="' + this.buyingJourneyObject.cill.variantId + '"]'
      );
      selectedOption.checked = true;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    this.setupOptionListeners('input[name="cill"]');
    console.log(this.buyingJourneyObject);
  }

  getCill() {
    console.log('PostCode');

    this.updateGlassValues(); // update the glass values
    const selectedThreshold = document.querySelector('input[name="threshold"]:checked');
    if (selectedThreshold) {
      this.buyingJourneyObject.threshold.value = selectedThreshold.value;
      this.buyingJourneyObject.threshold.variantId = selectedThreshold.dataset.variantId;
      this.buyingJourneyObject.threshold.totalPrice = convertPrice(selectedThreshold.dataset.price);

      if (selectedThreshold.value.includes('integrated')) {
        this.buyingJourney.prevStepButton.dataset.decrement = 1;
        this.buyingJourneyObject.cill.value = null;
        this.buyingJourneyObject.cill.variantId = null;
        this.buyingJourneyObject.cill.totalPrice = 0;
      } else {
        this.buyingJourney.prevStepButton.dataset.decrement = 0;

        const selectedCill = this.buyingJourney.querySelector('input[name="cill"]:checked');

        if (selectedCill) {
          this.buyingJourneyObject.cill.value = selectedCill.value;
          this.buyingJourneyObject.cill.variantId = selectedCill.dataset.variantId;
          this.buyingJourneyObject.cill.totalPrice = this.convertPrice(
            selectedCill.dataset.price * parseFloat(this.buyingJourneyObject.panelInfo.panelWidth / 1000)
          );
        }
      }
    }

    if (this.buyingJourneyObject.postCode.value != null) {
      const selectedOption = this.buyingJourney.querySelector('input[name="post-code"]');
      selectedOption.value = this.buyingJourneyObject.postCode.value;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    const postCodeOptions = this.buyingJourney.querySelector('input[name="post-code"]');
    const postCodeInputs = [postCodeOptions];
    disableNextButtonOnEmptyInput(postCodeInputs);

    if (postCodeOptions) {
      postCodeOptions.addEventListener('change', function () {
        this.buyingJourneyObject.postCode.value = postCodeOptions.value;
        disableNextButtonOnEmptyInput(postCodeInputs);
      });
    }

    this.buyingJourney.nextStepButton.dataset.increment = 0;
    console.log(this.buyingJourneyObject);
  }

  getpostcode() {
    this.updateGlassValues(); // update the glass values
    console.log('Access Issues');
    const accessIssuesOptions = this.buyingJourney.querySelectorAll('input[name="delivery_access_issues"]');
    this.buyingJourney.setDisableNextButton();
    if (accessIssuesOptions) {
      accessIssuesOptions.forEach((radio) => {
        radio.addEventListener('change', () => {
          this.buyingJourney.setDisableNextButton();
          const selectedAccessIssue = this.buyingJourney.querySelector('input[name="delivery_access_issues"]:checked');
          this.buyingJourneyObject.accessIssue.value = selectedAccessIssue.value;
          const accessIssueNote = this.buyingJourney.querySelector('textarea[name="access_issues_order_note"]');
          if (this.buyingJourneyObject.accessIssue.value == 'Yes') {
            accessIssueNote.addEventListener('change', () => {
              this.buyingJourney.setDisableNextButton();
              this.buyingJourneyObject.accessIssue.orderNote = accessIssueNote.value;
              if (
                this.buyingJourneyObject.accessIssue.value == 'Yes' &&
                this.buyingJourneyObject.accessIssue.orderNote != null &&
                this.buyingJourneyObject.accessIssue.orderNote.trim() !== ''
              ) {
                this.buyingJourney.setActiveNextButton();
              }
            });
          } else if (this.buyingJourneyObject.accessIssue.value == 'No') {
            accessIssueNote.value = null;
            this.buyingJourneyObject.accessIssue.orderNote = null;
            if (
              this.buyingJourneyObject.accessIssue.value == 'No' &&
              this.buyingJourneyObject.accessIssue.orderNote == null
            ) {
              this.buyingJourney.setActiveNextButton();
            }
          }
        });
      });
      if (this.buyingJourneyObject.accessIssue.value != null) {
        const selectedOption = this.buyingJourney.querySelector(
          'input[name="delivery_access_issues"][value="' + this.buyingJourneyObject.accessIssue.value + '"]'
        );
        selectedOption.checked = true;
        if (this.buyingJourneyObject.accessIssue.value == 'Yes') {
          this.buyingJourney.querySelector('input[name="access_issues_order_note"]').value =
            this.buyingJourneyObject.accessIssue.orderNote;
        }
        selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
      }
    }
    this.buyingJourney.prevStepButton.dataset.decrement = 0;
    console.log(this.buyingJourneyObject);
  }

  //Gate access
  getGatewayAccessQuote() {
    console.log('Gateway Access');
    if (this.buyingJourneyObject.gtAccessQoute.firstName != null) {
      const selectedOption = this.buyingJourney.querySelector('input[name="contact[firstName]"]');
      selectedOption.value = this.buyingJourneyObject.gtAccessQoute.firstName;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }
    if (this.buyingJourneyObject.gtAccessQoute.lastName != null) {
      const selectedOption = this.buyingJourney.querySelector('input[name="contact[lastName]"]');
      selectedOption.value = this.buyingJourneyObject.gtAccessQoute.lastName;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }
    if (this.buyingJourneyObject.gtAccessQoute.email != null) {
      const selectedOption = this.buyingJourney.querySelector('input[name="contact[email]"]');
      selectedOption.value = this.buyingJourneyObject.gtAccessQoute.email;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    if (this.buyingJourneyObject.gtAccessQoute.mobile != null) {
      const selectedOption = this.buyingJourney.querySelector('input[name="contact[phone]"]');
      selectedOption.value = this.buyingJourneyObject.gtAccessQoute.mobile;
      selectedOption.dispatchEvent(this.buyingJourney.changeEvent);
    }

    const accessQuoteInputs = this.buyingJourney.querySelectorAll('.step-gtaq input');
    disableNextButtonOnEmptyInput(accessQuoteInputs);
    accessQuoteInputs.forEach((input) => {
      input.addEventListener('change', function () {
        switch (input.name) {
          case 'contact[firstName]':
            if (input.value.length > 0) {
              this.buyingJourneyObject.gtAccessQoute.firstName = input.value;
            } else {
              this.buyingJourneyObject.gtAccessQoute.firstName = null;
            }
            break;
          case 'contact[lastName]':
            if (input.value.length > 0) {
              this.buyingJourneyObject.gtAccessQoute.lastName = input.value;
            } else {
              this.buyingJourneyObject.gtAccessQoute.lastName = null;
            }
            break;
          case 'contact[phone]':
            {
              const IsValidFormat = validateAndFormatPhone(input.value, 'GB');
              console.log('Is phone number is valid? ' + IsValidFormat.valid);
              if (input.value.length == 11 && IsValidFormat.valid) {
                this.buyingJourneyObject.gtAccessQoute.mobile = input.value;
                input.classList.remove('invalid');
              } else {
                this.buyingJourneyObject.gtAccessQoute.mobile = null;
                input.classList.add('invalid');
              }
            }
            break;
          case 'contact[email]':
            if (this.buyingJourney.validateEmail()) {
              console.log('valid Email');
              this.buyingJourneyObject.gtAccessQoute.email = input.value;
            } else {
              console.log('Invalid Email');
              this.buyingJourneyObject.gtAccessQoute.email = null;
            }
            break;
          default:
            console.log('no input');
            break;
        }

        if (
          this.buyingJourneyObject.gtAccessQoute.firstName &&
          this.buyingJourneyObject.gtAccessQoute.lastName &&
          this.buyingJourneyObject.gtAccessQoute.mobile &&
          this.buyingJourneyObject.gtAccessQoute.email
        ) {
          this.buyingJourney.setActiveNextButton();
        } else {
          this.buyingJourney.setDisableNextButton();
        }
      });
    });
  }

  handleAddMoreProducts() {
    this.buyingJourney.setDisableNextButton();

    this.buyingJourney.querySelectorAll('.add-product-label').forEach((input) =>
      input.addEventListener('click', async function () {
        if (this.dataset.url && this.dataset.url != '#') {
          document.querySelector('.adding-to-cart-loading-wraper').style.display = 'block';
          await createBuyingJourneyProduct();
          console.log('Product Added to cart, Ready to switch to new page');
          document.querySelector('.adding-to-cart-loading-wraper').style.display = 'none';
          window.location.href = this.dataset.url;
        }
        if (this.value == 'nothanks') {
          this.buyingJourneyObject.createQuoteFlag = true; //set the quote flag to true to generate the quote
          this.buyingJourney.nextStepButton.disabled = false;
          this.buyingJourney.nextStepButton.classList.remove('disabled');
        }
      })
    );

    const noThanksLabel = this.buyingJourney.querySelector('#no-thanks');

    if (noThanksLabel.checked) {
      this.buyingJourney.setActiveNextButton();
    }
  }

  getProductFinalPrice() {
    this.buyingJourneyObject.totalPrice = Math.round(
      this.convertPrice(
        this.buyingJourneyObject.panelSize.totalPrice * this.buyingJourneyObject.panelSize.quantity +
          this.buyingJourneyObject.panelOutsideColour.totalPrice *
            this.buyingJourneyObject.panelOutsideColour.quantity +
          this.buyingJourneyObject.panelInsideColour.totalPrice * this.buyingJourneyObject.panelInsideColour.quantity +
          this.buyingJourneyObject.panelHandle.totalPrice * this.buyingJourneyObject.panelHandle.quantity +
          this.buyingJourneyObject.panelGlass.totalPrice * this.buyingJourneyObject.panelGlass.quantity +
          this.buyingJourneyObject.barsfitting.totalPrice * this.buyingJourneyObject.barsfitting.quantity +
          this.buyingJourneyObject.trickleVents.totalPrice * this.buyingJourneyObject.trickleVents.quantity +
          (this.buyingJourneyObject.profileAddons.leftPrice +
            this.buyingJourneyObject.profileAddons.rightPrice +
            this.buyingJourneyObject.profileAddons.topPrice) +
          this.buyingJourneyObject.cill.totalPrice +
          this.buyingJourneyObject.threshold.totalPrice +
          this.buyingJourneyObject.blinds.totalPrice
      )
    );
    return this.buyingJourneyObject.totalPrice;
  }

  collectProductData() {
    const productData = {
      title: 'Your Aluminium Bifold Door Order',
      handle: 'your-order-' + generateRandomSixDigitNumber(),
      body_html: `
        <p style="text-align: left;"><strong>Access Issues: </strong> ${
          this.buyingJourneyObject.accessIssue.value == 'No'
            ? this.buyingJourneyObject.accessIssue.value
            : this.buyingJourneyObject.accessIssue.orderNote
        }</p>
        <p style="text-align: left;"><strong>Manufacturing Size: </strong> ${
          this.buyingJourneyObject.panelInfo.panelWidth + 'x' + this.buyingJourneyObject.panelInfo.panelHeight
        }</p>
        <p style="text-align: left;"><strong>Panels: </strong> ${this.buyingJourneyObject.panelSize.value}</p>
        <p style="text-align: left;"><strong>Stacking Direction: </strong>${
          this.buyingJourneyObject.panelSize.stackingDirection
        }</p>
        <p style="text-align: left;"><strong>Opening Direction: </strong>  ${
          this.buyingJourneyObject.panelInfo.orientation
        }</p>
        <p style="text-align: left;"><strong>Outside Colour: </strong> ${
          this.buyingJourneyObject.panelOutsideColour.value
        }</p>
        <p style="text-align: left;"><strong>Inside Colour: </strong> ${
          this.buyingJourneyObject.panelInsideColour.value
        }</p>
        <p style="text-align: left;"><strong>Cill: </strong>${this.buyingJourneyObject.cill.value}</p>
        <p style="text-align: left;"><strong>Threshold: </strong>${this.buyingJourneyObject.threshold.value}</p>
        <p style="text-align: left;"><strong>Glass: </strong>${this.buyingJourneyObject.panelGlass.value}</p>
        <p style="text-align: left;"><strong>Blinds: </strong>${this.buyingJourneyObject.blinds.value}</p>
        <p style="text-align: left;"><strong>Handle Colour: </strong>${this.buyingJourneyObject.panelHandle.value}</p>
        <p style="text-align: left;"><strong>Trickle Vents: </strong>${this.buyingJourneyObject.trickleVents.value}</p>
        <p style="text-align: left;"><strong>Top Addon: </strong>${this.buyingJourneyObject.profileAddons.top}</p>
        <p style="text-align: left;"><strong>Right Addon: </strong>${this.buyingJourneyObject.profileAddons.right}</p>
        <p style="text-align: left;"><strong>Left Addon: </strong>${this.buyingJourneyObject.profileAddons.left}</p>
        <p style="text-align: left;"><strong>Hinge Colour: </strong>Black</p>
        <p style="text-align: left;"><strong>Horizontal Astragal Bars: </strong>${
          this.buyingJourneyObject.barsfitting.direction == 'horizontal'
            ? this.buyingJourneyObject.barsfitting.direction
            : 'No'
        }</p>

        <p style="text-align: left;"><strong>Vertical Astragal Bars: </strong>${
          this.buyingJourneyObject.barsfitting.direction == 'vertical'
            ? this.buyingJourneyObject.barsfitting.direction
            : 'No'
        }</p>
        <p style="text-align: left;"><strong>Total price:</strong> £${this.buyingJourneyObject.totalPrice} </p>
        `,
      vendor: 'NOW Aluminium',
      product_type: 'quote-product',
      variants: [
        {
          price: getProductFinalPrice(),
        },
      ],
      images: [
        {
          src: this.buyingJourneyObject.panelSize.panelImage, // Assuming this is the URL to the product image
        },
      ],
      properties: getProductProperties(),
    };
    return productData;
  }

  //Helper Functions

  validateInput(productObject, input) {
    const { buyingJourney } = this;
    if (input) {
      switch (input.name) {
        case 'panel-width':
          productObject.panelInfo.panelWidth = parseInt(input.value, 10) || 0;
          break;
        case 'panel-height':
          productObject.panelInfo.panelHeight = parseInt(input.value, 10) || 0;
        default:
          break;
      }
      var isValid = true;
      const value = parseInt(input.value, 10);
      if (!isNaN(value)) {
        isValid = true;
        if (input.hasAttribute('min') && input.hasAttribute('max')) {
          isValid = value >= input.min && value <= input.max;
        }
      }
      input.classList.toggle('invalid', !isValid);
      if (input.parentElement.nextElementSibling) {
        input.parentElement.nextElementSibling.classList.toggle('show', !isValid);
      }
      if (this.validateStep()) {
        return true;
      } else {
        return false;
      }
    }
  }

  setIncrementForButtons(selectedFitting, triggerStepNumber = null) {
    const selectedFittingDowncase = selectedFitting.toLowerCase();
    switch (selectedFittingDowncase) {
      case 'yes':
        this.buyingJourney.unskipNextNSteps(2, triggerStepNumber);
        this.buyingJourney.nextStepButton.dataset.increment = 0;
        break;
      case 'no':
        this.buyingJourney.skipNextNSteps(2, triggerStepNumber);
        this.buyingJourney.nextStepButton.dataset.increment = 2;
        break;
      default:
        // do nothing
        break;
    }
  }

  setDecrementForButtons(selectedFitting) {
    const { buyingJourney } = this;
    switch (selectedFitting) {
      case 'yes':
        this.buyingJourney.prevStepButton.dataset.decrement = 0;
        break;
      case 'no':
        this.buyingJourney.prevStepButton.dataset.decrement = 2;
        break;
      case 'skipAstragal':
        this.buyingJourney.prevStepButton.dataset.decrement = 3;
        break;
      default:
        // do nothing
        break;
    }
    this.buyingJourney.nextStepButton.dataset.increment = 0;
  }

  validateStep() {
    const activeInputs = this.buyingJourney.querySelectorAll('.step-container.active input');
    return Array.from(activeInputs).every((input) => input && input.value && !input.classList.contains('invalid'));
  }

  setupOptionListeners(selector) {
    const options = this.buyingJourney.querySelectorAll(selector);
    options.forEach((option) =>
      option.addEventListener('change', () => {
        if (option) option.checked = true;
        this.disableNextButtonOnNonSelection(options);
      })
    );
    this.disableNextButtonOnNonSelection(options);
  }

  disableNextButtonOnNonSelection(options) {
    const anyChecked = Array.from(options).some((option) => option && option.checked);
    if (anyChecked) {
      this.buyingJourney.setActiveNextButton();
    } else {
      this.buyingJourney.setDisableNextButton();
    }
  }

  convertPrice(price) {
    let priceRounded;
    if (price) {
      let decimalPrice = parseFloat(price); // Convert the price to a float
      priceRounded = Math.round(decimalPrice * 100.0) / 100; // Multiply by 100, round, then divide by 100
    } else {
      priceRounded = 0;
    }
    return priceRounded;
  }

  disableNextButtonOnEmptyInput(inputs) {
    const allFilled = Array.from(inputs).every((input) => input && input.value.trim() !== '');
    if (allFilled) {
      this.buyingJourney.setActiveNextButton();
    } else {
      this.buyingJourney.setDisableNextButton();
    }
  }

  getProductProperties() {
    return {
      'First name': `${this.buyingJourneyObject.gtAccessQoute.firstName}`,
      'Last name': `${this.buyingJourneyObject.gtAccessQoute.lastName}`,
      Email: `${this.buyingJourneyObject.gtAccessQoute.email}`,
      Phone: `${this.buyingJourneyObject.gtAccessQoute.mobile}`,
      Postcode: `${this.buyingJourneyObject.postCode}`,
      'Panel width': `${this.buyingJourneyObject.panelInfo.panelWidth}`,
      'Panel height': `${this.buyingJourneyObject.panelInfo.panelHeight}`,
      Orientation: `${this.buyingJourneyObject.panelInfo.orientation}`,
      'No. of panels': `${this.buyingJourneyObject.panelSize.value}`,
      'Stacking direction': `${this.buyingJourneyObject.panelSize.stackingDirection}`,
      'Panel outside color': `${this.buyingJourneyObject.panelOutsideColour.value}`,
      'Panel inside color': `${this.buyingJourneyObject.panelInsideColour.value}`,
      'Panel handle': `${this.buyingJourneyObject.panelHandle.value}`,
      'Panel glass': `${this.buyingJourneyObject.panelGlass.value}`,
      Blinds: `${this.buyingJourneyObject.blinds.value}`,
      'Astragal bars': `${this.buyingJourneyObject.barsfitting.value}`,
      'Astragal bars direction': `${this.buyingJourneyObject.barsfitting.direction}`,
      'Number of astragal bars': `${this.buyingJourneyObject.barsfitting.quantity}`,
      'Trickle vents': `${this.buyingJourneyObject.trickleVents.value}`,
      'Profile addons': `${this.buyingJourneyObject.profileAddons.value}`,
      'Profile addons left': `${this.buyingJourneyObject.profileAddons.left}`,
      'Profile addons top': `${this.buyingJourneyObject.profileAddons.top}`,
      'Profile addons right': `${this.buyingJourneyObject.profileAddons.right}`,
      Postcode: `${this.buyingJourneyObject.postCode.value}`,
      Cill: `${this.buyingJourneyObject.cill.value}`,
      Threshold: `${this.buyingJourneyObject.threshold.value}`,
      'Access issues': `${this.buyingJourneyObject.accessIssue.value}`,
      'Access issues note': `${this.buyingJourneyObject.accessIssue.orderNote}`,
      'Panel image': `${this.buyingJourneyObject.panelSize.panelImage}`,
      'Verified Email': `${this.buyingJourney.emailVerified}`,
    };
  }

  convertOrderItemsIntoProductObject(orderItem) {
    console.log('convert Order items into Product');
    this.buyingJourneyObject.id = orderItem.id;
    this.buyingJourneyObject.title = orderItem.title;
    this.buyingJourneyObject.totalPrice = orderItem.price;
    this.buyingJourneyObject.panelSize.panelImage = orderItem.image;
    this.buyingJourneyObject.panelInfo.panelWidth = orderItem.properties['Panel width'];
    this.buyingJourneyObject.panelInfo.panelHeight = orderItem.properties['Panel height'];
    this.buyingJourneyObject.panelInfo.orientation = orderItem.properties['Orientation'];

    this.buyingJourneyObject.panelSize.value = orderItem.properties['No. of panels'];
    this.buyingJourneyObject.panelSize.stackingDirection = orderItem.properties['Stacking direction'];

    this.buyingJourneyObject.panelOutsideColour.value = orderItem.properties['Panel outside color'];

    this.buyingJourneyObject.panelInsideColour.value = orderItem.properties['Panel inside color'];

    this.buyingJourneyObject.panelHandle.value = orderItem.properties['Panel handle'];

    this.buyingJourneyObject.panelGlass.value = orderItem.properties['Panel glass'];

    this.buyingJourneyObject.blinds.value = orderItem.properties['Blinds'];

    this.buyingJourneyObject.barsfitting.value = orderItem.properties['Number of astragal bars'];
    this.buyingJourneyObject.barsfitting.direction = orderItem.properties['Astragal bars direction'];

    this.buyingJourneyObject.trickleVents.value = orderItem.properties['Trickle vents'];

    this.buyingJourneyObject.profileAddons.left = orderItem.properties['Profile addons left'];
    this.buyingJourneyObject.profileAddons.right = orderItem.properties['Profile addons right'];
    this.buyingJourneyObject.profileAddons.top = orderItem.properties['Profile addons top'];
    this.buyingJourneyObject.profileAddons.value = orderItem.properties['Profile addons'];

    this.buyingJourneyObject.postCode.value = orderItem.properties['Postcode'];

    this.buyingJourneyObject.cill.value = orderItem.properties['Cill'];

    this.buyingJourneyObject.threshold.value = orderItem.properties['Threshold'];

    this.buyingJourneyObject.accessIssue.value = orderItem.properties['Access issues'];
    this.buyingJourneyObject.accessIssue.orderNote = orderItem.properties['Access issues note'];

    this.buyingJourneyObject.gtAccessQoute.firstName = orderItem.properties['First name'];
    this.buyingJourneyObject.gtAccessQoute.lastName = orderItem.properties['Last name'];
    this.buyingJourneyObject.gtAccessQoute.mobile = orderItem.properties['Phone'];
    this.buyingJourneyObject.gtAccessQoute.email = orderItem.properties['Email'];

    return this.buyingJourneyObject;
  }
  // Create individual quote item element
  createQuoteItemElement(item) {
    const { buyingJourney } = this;
    const div = document.createElement('div');
    div.className = 'bj-cart-bottom';
    div.innerHTML = `
    <div class="bj-cart-bottom-right-top accordion-toggle">
      <div class="cart-accor-header-left">
        <h2 class="bj-cart-heading accordion-toggle">${item.title}</h2>
        <div class="bj-cart-total-price">
          <span class="bj-cart-price" data-order-price>${Shopify.formatMoney(item.totalPrice)}</span>
          <span class="bj-cart-price-text">+ VAT</span>
        </div>
      </div>
      <div class="cart-accor-header-left">
        <button type="button" class="accordion-toggle">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
            <rect y="0.224609" width="28" height="28" rx="14" fill="#6CAFC9"/>
            <path d="M7.51465 15.8193L13.9999 9.33398L20.4852 15.8193" stroke="#FAFCFF" stroke-width="1.64706" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
    <div class="bj-cart-bottom-in">
      <div class="bj-cart-bottom-in-left">
        <div class="cart-item-image">
          <img id="order-featured-image" src="${item.panelSize.panelImage}" alt="${item.title}" class="bj-cart-image" />
        </div>
      </div>
      <div class="bj-cart-bottom-in-right">
        <div class="bj-cart-bottom-right-center">
          <h3 class="bj-cart-detail-heading">Your door</h3>
          <div class="bj-cart-details">
            ${buyingJourney.renderDetail(
              'Manufacturing size (mm)',
              `${item.panelInfo.panelWidth} x ${item.panelInfo.panelHeight}`,
              'step-1',
              'dimension'
            )}
            ${buyingJourney.renderDetail(
              'Stacking direction',
              item.panelSize.stackingDirection,
              'step-2',
              'stacking-direction'
            )}
            ${buyingJourney.renderDetail('Outside colour', item.panelOutsideColour.value, 'step-4', 'outside-color')}
            ${buyingJourney.renderDetail(
              'Access issues',
              item.accessIssue.orderNote == 'null' ? 'No' : item.accessIssue.orderNote,
              'step-17',
              'access-issue'
            )}
            ${buyingJourney.renderDetail(
              'Opening directions',
              item.panelInfo.orientation,
              'step-3',
              'opening-direction'
            )}
            ${buyingJourney.renderDetail('Top addon', item.profileAddons.top, 'step-13', 'addon')}
            ${buyingJourney.renderDetail('Handle colour', item.panelHandle.value, 'step-6')}
            ${buyingJourney.renderDetail('Left addon', item.profileAddons.left, 'step-13', 'addon')}
            ${buyingJourney.renderDetail(
              'Trickle vents',
              item.trickleVents.value,
              'order-trickle-vents',
              'trickle-vents'
            )}
            ${buyingJourney.renderDetail('Hinge colour', 'Black', 'hinge-color')}
            ${buyingJourney.renderDetail(
              'Horizontal Astragal bars',
              item.barsfitting.direction === 'Horizontal' ? item.barsfitting.direction : 'No',
              'step-9',
              'astragal-bars'
            )}
            ${buyingJourney.renderDetail('Right addon', item.profileAddons.right, 'step-13', 'addon')}
            ${buyingJourney.renderDetail('Panels', item.panelSize.value, 'step-2', 'panels')}
            ${buyingJourney.renderDetail('Inside colour', item.panelInsideColour.value, 'step-5', 'inside-colour')}
            ${buyingJourney.renderDetail(
              'Vertical Astragal bars',
              item.barsfitting.direction === 'Vertical' ? item.barsfitting.direction : 'No',
              'step-9',
              'astragal-bars'
            )}
          </div>
          <div class="bj-cart-bottom-right-down">
            <h3 class="bj-cart-detail-heading">Upgrades</h3>
            <div class="bj-cart-bottom-details">
              <div class="bj-cart-bottom-details-left">
                ${buyingJourney.renderDetail('RAL colour', item.panelOutsideColour.value, 'step-4', 'outside-color')}
                ${buyingJourney.renderDetail('Glass', item.panelGlass.value, 'step-7', 'glass')}
                ${buyingJourney.renderDetail(
                  'Cill',
                  item.cill.value === 'null' ? 'No' : item.cill.value,
                  'step-15',
                  'cill'
                )}
                ${buyingJourney.renderDetail(
                  'Blinds',
                  item.blinds.value === 'null' ? 'No' : item.blinds.value,
                  'step-8',
                  'blinds'
                )}
                ${buyingJourney.renderDetail('Threshold', item.threshold.value, 'step-14', 'threshold')}
                ${buyingJourney.renderDetail('Delivery', 'Standard', 'order-delivery')}
              </div>
            </div>
  
            <div class="product-cta">
              <a class="bj-cart-image-text removeQuoteProduct" data-item-id="${item.id}">
                <span>Remove</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                  <rect x="21.8047" y="0.199219" width="21.601" height="21.601" rx="10.8005" transform="rotate(90 21.8047 0.199219)" fill="#4A5EAB"/>
                  <path d="M8.45014 7.98345L14.0186 7.98345L14.0186 13.5519M13.6319 8.37015L7.9861 14.016" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;

    // Attach remove handler
    div
      .querySelector('.removeQuoteProduct')
      ?.addEventListener('click', () => buyingJourney.removeQuoteProduct(item.id));
    div.querySelectorAll('.edit-option')?.forEach((option) =>
      option.addEventListener('click', () => {
        this.configurationPopup.openConfigurationDialog(option, item.id);
      })
    );
    return div;
  }
}

window.InternalDoor = InternalDoor;
